export const enumWidgetType = {
  pendo: "pendo",
  stonly: "stonly",
  onramp: "onramp",
  nativeResourceCenter: "nativeResourceCenter"
};

export const enumWidgetTrigger = {
  help: "help",
  passive: "passive"
};
